import { incrementViewCount, incrementClickCount } from "../Data/Functions/index";

const viewQueues = new Map();
const clickQueues = new Map();
const sentViews = new Map();
const sentClicks = new Map();
let currentUserId = null;

export const initNotificationStatsQueue = (uid) => {
    console.log('🔧 Initializing notification stats queue for user:', uid);
    currentUserId = uid;
    
    if (!viewQueues.has(uid)) {
        viewQueues.set(uid, new Set());
    }
    if (!clickQueues.has(uid)) {
        clickQueues.set(uid, new Set());
    }
    if (!sentViews.has(uid)) {
        sentViews.set(uid, new Set());
    }
    if (!sentClicks.has(uid)) {
        sentClicks.set(uid, new Set());
    }
};

const flush = async (type, userId) => {
    if (!userId) {
        console.log('❌ No userId provided for flush');
        return;
    }
    
    const queueMap = type === "view" ? viewQueues : clickQueues;
    const sentMap = type === "view" ? sentViews : sentClicks;
    
    const queue = queueMap.get(userId);
    const sent = sentMap.get(userId);
    
    if (!queue || !queue.size) {
        console.log(`📭 No ${type} queue for user ${userId}`);
        return;
    }

    const notifIds = Array.from(queue);
    queue.clear();

    console.log(`📤 Flushing ${type} queue for user ${userId}:`, notifIds);

    try {
        let response;
        if (type === "view") {
            response = await incrementViewCount(notifIds, userId);
        } else {
            response = await incrementClickCount(notifIds, userId);
        }

        if (response?.success) {
            notifIds.forEach(id => sent.add(id));
            
            const stats = response.stats || {};
            console.log(`✅ [${type.toUpperCase()}] User ${userId}: ${notifIds.length} processed, ${stats.incremented || 0} incremented, ${stats.skipped || 0} skipped`);
        } else {
            console.log(`⚠️ [${type.toUpperCase()}] Partial success for user ${userId}:`, response);
        }

    } catch (error) {
        console.error(`❌ Error flushing ${type} queue for user ${userId}:`, error);
        notifIds.forEach(id => queue.add(id));
    }
};

const debouncedFlush = (() => {
    const timers = new Map();

    return (type, userId) => {
        if (!userId) return;
        
        if (!timers.has(userId)) {
            timers.set(userId, { view: null, click: null });
        }
        
        const userTimers = timers.get(userId);
        clearTimeout(userTimers[type]);
        
        userTimers[type] = setTimeout(() => {
            flush(type, userId);
        }, 2000);
    };
})();

export const trackView = (notifId, userId = currentUserId) => {
    if (!notifId || !userId) {
        console.log('❌ Missing notifId or userId for trackView:', { notifId, userId });
        return;
    }
    
    const viewQueue = viewQueues.get(userId);
    const sentView = sentViews.get(userId);
    
    if (!viewQueue || !sentView) {
        console.log('❌ User queues not initialized for:', userId);
        return;
    }
    
    if (viewQueue.has(notifId) || sentView.has(notifId)) {
        console.log('⚠️ View already queued/sent for user:', userId, 'notification:', notifId);
        return;
    }
    
    console.log('👁️ Tracking view for user:', userId, 'notification:', notifId);
    viewQueue.add(notifId);
    debouncedFlush("view", userId);
};

export const trackClick = (notifId, userId = currentUserId) => {
    if (!notifId || !userId) {
        console.log('❌ Missing notifId or userId for trackClick:', { notifId, userId });
        return;
    }
    
    const clickQueue = clickQueues.get(userId);
    const sentClick = sentClicks.get(userId);
    
    if (!clickQueue || !sentClick) {
        console.log('❌ User queues not initialized for:', userId);
        return;
    }
    
    if (clickQueue.has(notifId) || sentClick.has(notifId)) {
        console.log('⚠️ Click already queued/sent for user:', userId, 'notification:', notifId);
        return;
    }
    console.log('👆 Tracking click for user:', userId, 'notification:', notifId);
    clickQueue.add(notifId);
    debouncedFlush("click", userId);
};

export const clearUserStats = (userId) => {
    console.log('🧹 Clearing stats for user:', userId);
    viewQueues.delete(userId);
    clickQueues.delete(userId);
    sentViews.delete(userId);
    sentClicks.delete(userId);
};